export default __webpack_public_path__ + "static/media/Logo_CSharp.ed4a3a1c.svg";